import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#62B47C",
        },
        secondary: {
            main: "#133257",
        },
    },
});

export default theme;